import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReturnUrlService } from '@lx/quote-tool/lite/shared/services';
import { getCompany, getConfiguration } from '@lx/shared/tokens';
import { ButtonComponent } from '@lx/shared/ui/button';
import { CompanyFormattedNamePipe } from '@lx/shared/ui/pipes';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import { NavigationService } from '../../../services';
import { QuoteToolLiteStore } from '../../../store';

@Component({
  standalone: true,
  imports: [ButtonComponent, CompanyFormattedNamePipe, AsyncPipe],
  selector: 'lx-confirmation-step',
  templateUrl: './confirmation-step.component.html',
  styleUrls: ['./confirmation-step.component.scss'],
  providers: [ConfirmationService],
})
export class ConfirmationStepComponent implements OnInit {
  contactLink: string | undefined;
  studentFirstName$: Observable<string> | undefined;

  readonly company = getCompany();

  protected backButtonLabel: string | undefined;

  private readonly qtLiteStore = inject(QuoteToolLiteStore);
  private readonly navigationService = inject(NavigationService);
  private readonly returnUrlService = inject(ReturnUrlService);
  private readonly configuration = getConfiguration();

  ngOnInit(): void {
    this.contactLink = this.configuration.QUOTE_TOOL_CONTACT_LINK as string;
    this.studentFirstName$ = this.qtLiteStore.studentFirstName$;
    this.backButtonLabel = this.returnUrlService.getBackButtonLabel() || $localize`Start a new quote`;
  }

  closeQuoteToolLite(): void {
    this.navigationService.closeQuoteToolLite();
  }
}
